import styled from "styled-components";
import {CharcoalBlack, White, AshGrey, Teal} from "../../../theme/variable";
import right_panel_bg from "../../../images/right_panel_bg.jpg";
import SA_profile from "../../../images/SA_profile.svg";
import {media} from "../../../theme/responsive";

export const RightPanel = styled.div`
    background: ${White};
    color: ${CharcoalBlack};
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 10;
    box-shadow: -3px 0 8px 0 rgba(0, 0, 0, 0.2);
`;
export const TopSection = styled.div`
    padding:18px 16px;
    // background: #007075 url(${right_panel_bg}) no-repeat top center;
    background:#007075;
    background-size: cover;
    position: relative;
`;
export const ProfileDiv = styled.div`
    border: 1px solid #ccc;
    border-radius: 50%;
    background: url(${(props) => (props.profilePic ? props.profilePic : SA_profile)});
    display: inline-block;
    vertical-align: middle;
    width: 60px;
    height: 60px;
    background-size: cover;
    .usr-pic {
        width: 60px;
        height: 60px;
        border-radius: 50px;
        background-repeat: no-repeat;
        overflow: hidden;
        background-position: top center;
    }
`;

export const UserInfo = styled.div`
    display: inline-block;
    padding-left: 10px;
    width: 70%;
    margin-left: 2px;
    box-sizing: border-box;
    word-break: break-word;
    vertical-align: middle;
    color: ${White};
    h1 {
        font-size: 1rem;
        line-height: initial;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 600;
        padding: 0;
    }
    a {
        color: ${White};
        padding: 4px 6px;
        &:hover {
            background: rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            cursor: pointer;
            font-weight: 600;
        }
    }
    span {
        color: ${White};
        margin: 0 8px;
        display: inline-block;
        opacity: 0.6;
    }
`;

export const MiddleSection = styled.div`
      width:100%;
      overflow: auto;
      position: absolute;
      max-height: 200em;
      bottom: 8px;
      top: 92px;
}
`;

export const TabDiv = styled.div`
    position: relative;
    margin-bottom: 1px;
    width: 100%;
    color: ${CharcoalBlack};
    overflow: hidden;
    font-size: 0.875rem;
    margin: 0;
    label {
        position: relative;
        display: inline-block;
        background: ${White};
        font-weight: 400;
        padding: 16px 10px;
        cursor: pointer;
        // border-bottom: 1px solid #c1e8dc;
        -webkit-tap-highlight-color: transparent;
        width: 100%;
        color: ${CharcoalBlack};
        position: relative;
        box-shadow: inset 0px -1px 0px rgb(0 0 0 / 5%);
        a,
        a:hover {
            color: ${Teal};
            font-size: 0.875rem;
        }
        &:after {
            position: absolute;
            right: 0;
            top: 0;
            display: block;
            width: 3em;
            height: 3em;
            line-height: 3;
            text-align: center;
            transition: all 0.5s;
        }
    }

    label.checked {
        border-bottom: 1px solid ${White};
        margin-bottom: 2px;
    }
    i.downArrow {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid ${CharcoalBlack};
        float: right;
        margin-right: 4px;
        margin-top: 5px;
        transform: ${(props) => (props.maxHeight > 0 ? "rotate(180deg)" : "rotate(0deg)")};
    }
    span.unread {
        font-weight: 600;
        color: ${AshGrey};
    }
`;
export const TabContent = styled.div`
    width: 100%;
    background: #e4f5f0;
    max-height: ${(props) => props.maxHeight}em;
    transition: max-height 0.5s;
    p {
        width: 100%;
    }
    && ul {
        padding: 0;
        li {
            border-bottom: 1px solid #c1e8dc;
            line-height: 20px;
            margin-bottom: 0;
            padding: 10px 10px 10px 15px;
            list-style: none;
            &:first-child {
                padding-top: 10px;
            }
            span {
                font-size: 0.875rem;
                line-height: 21px;
            }
            span.timeTag {
                font-size: 0.75rem;
                line-height: 18px;
            }
        }
    }
`;
export const BottomSection = styled.div`
    padding: 10px;
    background: ${White};
    position: absolute;
    bottom: 0;
    border-top: 1px solid #c1e8dc;
    width: 100%;
    box-sizing: border-box;
`;
export const AnchorTag = styled.a`
    color: ${(props) => (props.logout ? "#008489" : "#ffffff")};
    text-decoration: none;
    font-size: ${(props) => (props.logout ? "0.875rem" : "0.875rem")};
    font-weight: 600;
    cursor: pointer;
    display: inline-block;
    position: absolute;
    bottom: 12px;
    right: 12px;
    &:hover {
        color: ${(props) => (props.logout ? "#008489" : "#ffffff")};
    }
`;
export const DashboardTag = styled.div`
    // background: ${(props) => (props.newTag ? "#F37921" : "#008489")};
    color: #007075;
    width: auto;
    font-size: 0.875rem;
    // padding: 1px 4px;
    // border-radius: 2px;
    display: inline-block;
    line-height: 11px;
    // position: absolute;
    margin-left: 4px;
    // top: ${(props) => (props.newTag ? "2px" : "")};
    // right: ${(props) => (props.newTag ? "-12px" : "")};
    // font-weight: ${(props) => (props.newTag ? "600" : "")};

    ${media.laptop`
        // top: ${(props) => (props.newTag ? "-10px" : "")};
        // right: ${(props) => (props.newTag ? "20px" : "")};
        // font-weight: ${(props) => (props.newTag ? "600" : "")};
    `}
`;
export const DashboardOptionList = styled.li`
    &&& span {
        color: ${(props) => (props.active ? "#008489" : "#000")};
        font-weight: ${(props) => (props.active ? "400" : "400")};
        &:hover {
            color: #008489;
            font-weight: 600;
        }
    }
`;
